import { HttpInterceptorFn } from '@angular/common/http';

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const supportSessionId = platformSupportSessionId();
  const shouldAttachSupportSession = !!supportSessionId && isSupportSessionServiceRequest(req.url);
  const credentialedRequest = req.credentials === 'include'
    ? req
    : req.clone({ withCredentials: false, credentials: 'include' });

  return next(shouldAttachSupportSession
    ? credentialedRequest.clone({ setHeaders: { 'X-Platform-Support-Session': supportSessionId } })
    : credentialedRequest);
};

function platformSupportSessionId(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.sessionStorage.getItem('platformSupportSessionId')?.trim() || null;
  } catch {
    return null;
  }
}

/** Services that admit a platform admin only through the support session (they verify it with property-service). */
const SUPPORT_SESSION_SERVICES = ['/property-service/', '/maintenance-service/', '/report-service/', '/calendar-service/'];

function isSupportSessionServiceRequest(url: string): boolean {
  return SUPPORT_SESSION_SERVICES.some((prefix) => url.includes(prefix));
}
